import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL || 'https://watchpassion.vercel.app/api'}/ebay`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

export const fetchWatches = async (forceRefresh = false) => {
  const response = await api.get('/listings', {
    params: forceRefresh ? { force: 'true' } : undefined,
  });

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Errore nel recupero degli annunci');
  }

  return response.data.data;
};

export const fetchWatchById = async (id) => {
  const response = await api.get(`/items/${id}`);

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Annuncio non trovato');
  }

  return response.data.data;
};

export const fetchWatchesByCategory = async (category) => {
  const response = await api.get(`/category/${encodeURIComponent(category)}`);

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Errore nel recupero per categoria');
  }

  return response.data.data;
};
